// Angular dependencies
import { Injectable } from '@angular/core';

import { ApiService, AuthService } from '../core/upgraded-providers';

@Injectable()
export class SteamService {
    constructor(
        private _apiSrv: ApiService,
        private _authSrv: AuthService
    ) {
    }

    async inventory(): Promise<any> {
        try {
            const { resources, decorations } = await this._apiSrv.get('steam/inventory', { });

            return { resources, decorations };
        } catch (err) {
            throw err;
        }
    }

    async push(data: { id: string }): Promise<void> {
        try {
            await this._apiSrv.post('steam/push-decorations', data);

            return;
        } catch (err) {
            throw err;
        }
    }

    async pull(data: { id: string }): Promise<string> {
        try {
            const { id } = await this._apiSrv.post('steam/pull-decorations', data);

            return id;
        } catch (err) {
            throw err;
        }
    }

    async pushResources(data: { resourceType: string, amount: number }): Promise<void> {
        try {
            await this._apiSrv.post('steam/push-resources', data);
        } catch (err) {
            let message;
            if (typeof err === 'string') {
                message = err;
            } else {
                message = (err && err.data && err.data.error) || 'Error';
            }

            throw new Error(message);
        }

        this._authSrv.check();
    }

    async pullResources(data: { resourceType: string, amount: number }): Promise<string> {
        try {
            const { id } = await this._apiSrv.post('steam/pull-resources', data);

            return id;
        } catch (err) {
            let message;
            if (typeof err === 'string') {
                message = err;
            } else {
                message = (err && err.data && err.data.error) || 'Error';
            }

            throw new Error(message);
        }
    }
}
